export const schedulerStyle = `

button {
  border-color: #2b2b2b !important;
  border-radius: 0!important;
  color: #2b2b2b !important;
  font-family: 'Montserrat' !important;
  font-size: 10px !important;
  font-weight: 400 !important;
  letter-spacing: 1.2px !important;
  text-transform: uppercase !important;
}
button.button-primary {
  background-color: #2b2b2b !important;
  color: #fff !important;
}
button.button-primary:hover {
  background-color: #3d3d3d !important;
}
button.button-basic:hover {
  border-color: #bea06e !important;
}
button.tab.active {
  border-color: #bea06e !important;
  color: #bea06e !important;
}
.configurations {
  border-radius: 0!important;
}
::part(actions__dropdown-button) {
  border-color: #2b2b2b !important;
  border-radius: 0px;
}
::part(actions__dropdown-button):hover {
  border-color: #bea06e !important;
  outline: none;
}

button:hover,
button:active{
  --nylas-primary: #bea06e;
  --nylas-base-600: #bea06e;
  --nylas-base-700: #bea06e;
}

::part(sd_dropdown){
  --nylas-primary: #bea06e;
}

::part(sd_dropdown):hover{
  --nylas-base-800: #bea06e;
}

::part(sd_dropdown):active{
  --nylas-base-300: #bea06e;
}

::part(id_dropdown){
  --nylas-primary: #bea06e;
}

nylas-participants-custom-availability::part(npca_toggle-slider),
nylas-confirmation-email::part(nce_toggle-slider),
nylas-disable-emails::part(nde_toggle-slider)
{
  --nylas-base-300: #3d3d3d !important;
  --nylas-success: #bea06e !important;
}
nylas-availability-picker::part(nap__time-picker-input):hover {
  border-color: #bea06e !important;
}
nylas-additional-participants::part(nap__add-participant):hover,
nylas-availability-picker::part(nap__add-time-range):hover {
  color: #bea06e !important;
}
nylas-participant-booking-calendars::part(npbc__header),
nylas-connected-calendars::part(nccals__header),
nylas-availability-picker::part(nap__header),
nylas-additional-participants::part(nap__subtitle),
nylas-buffer-time::part(nbt__header),
nylas-booking-form-config::part(nbfc__header),
nylas-confirmation-email::part(nce__header),
nylas-confirmation-email::part(nce__summary),
nylas-page-name::part(nces__header),
nylas-participants-custom-availability::part(npca__header),
.scheduler-editor.sc-nylas-editor-tabs .form-contents.sc-nylas-editor-tabs p.sc-nylas-editor-tabs,
.header .description p {
  --nylas-base-600: #3d3d3d !important;
}
.description p {
  font-family: 'Montserrat';
  --nylas-base-600: #3d3d3d;
}
nylas-calendar-picker::part(ncp__dropdown-button) {
  --nylas-font-family: '"Montserrat", sans-serif';
}
nylas-booking-form-config::part(nbfc__form_field-header) {
  --nylas-base-500: #3d3d3d !important;
  --nylas-base-600: #3d3d3d !important;
}
nylas-booking-form-config::part(nap__add-time-range) {
  font-family: 'Montserrat' !important;
}
select-dropdown::part(sd_dropdown-labelhtml):hover,
nylas-booking-form-config::part(nap__add-time-range):hover {
  --nylas-primary: #bea06e !important;
}
nylas-min-booking-notice::part(tps__number-dropdown-button),
nylas-limit-future-bookings::part(tps__number-dropdown-button),
nylas-min-cancellation-notice::part(tps__number-dropdown-button) {
  outline: none !important;
}
`;

export const localSchedulerCreateRootStyle = `
button:hover,
button:active{
  --nylas-primary: #bea06e;
}
`;

export const localSchedulerRootStyle = `
button:hover,
button:active{
  --nylas-primary: #bea06e;
  --nylas-base-600: #bea06e;
  --nylas-base-700: #bea06e;
}

::part(sd_dropdown){
  --nylas-primary: #bea06e;
}

::part(ic__input){
  --nylas-primary: #bea06e;
  font-family: 'Montserrat', sans-serif;
}

::part(tc__textarea){
  --nylas-primary: #bea06e;
}

::part(sd_dropdown):hover{
  --nylas-base-800: #bea06e;
}

::part(sd_dropdown):active{
  --nylas-base-300: #bea06e;
}

::part(id_dropdown){
  --nylas-primary: #bea06e;
  outline-color: #bea06e;
}

.nylas-availability-picker .content .availability .availability-day .day input[type="checkbox"],
.nylas-booking-form-config .content  .required-input input[type=checkbox],
.radio-group label .radio-option input[type=radio i],
.dropdown-content ul li label input {
  accent-color: #3d3d3d;
}
label input[type="checkbox"]:checked ~ .checkmark {
  --nylas-primary: #3d3d3d;
}
label .checkmark {
  --nylas-primary: #3d3d3d;
  outline-color: #3d3d3d;
}

.nylas-event-calendar button.button-invisible.sc-button-component:hover,
.nylas-event-calendar .dropdown .dropdown-label {
  color: #bea06e !important;
}

::part(net__title):focus,
::part(nedesc__textarea):focus{
  outline-color: #bea06e;
}

.nylas-event-calendar .day-number.today,
.nylas-event-calendar .fc-day-today .fc-daygrid-day-number {
  --nylas-primary: #bea06e;
}

.participant-tab {
  --nylas-border-radius-2x: 0;
  background-color: #fff;
  border: 1px solid #3d3d3d ;
}

button.button-basic.sc-button-component:hover {
  --nylas-base-700: #bea06e;
  border-color: #bea06e;
}

::part(times),
::part(ic__date),
::part(time-input),
.time-picker,
.time-picker input,
.time-picker input:hover,
.time-picker input:active,
::part(id_dropdown-input),
::part(sd_dropdown-button)
{
  outline-color: #bea06e;
  --nylas-primary: #bea06e;
}

input-dropdown.sc-time-period-selector{
  --nylas-primary: #bea06e !important;
}

div.nylas-event-timeslot div.date-time-input div.recurrence-options div.repeat-on div.days div.buttons button.selected{
  --nylas-primary: #bea06e;
}

::part(nstap__toggle-button),
::part(nstap__remove-button){
  --nylas-primary: #bea06e;
  --nylas-error: #bea06e;
}

.nylas-event-calendar .calendar-container .calendar-header__title{
  font-family: 'Montserrat', sans-serif;
}

.event-details-footer__actions{
  --nylas-border-radius-2x: 0px;
}

button.button-basic.sc-button-component{
  --nylas-base-300: #2b2b2b;
}

button.button-primary.sc-button-component:hover,
button.button-basic.sc-button-component:hover{
  --nylas-primary: #2b2b2b !important;
  --nylas-base-600: #2b2b2b !important;
  --nylas-base-700: #2b2b2b !important;
}

.event-details-footer__actions,
.discard-changes__footer {
  button.button-primary.sc-button-component:hover,
  button.button-basic.sc-button-component:hover{
    --nylas-primary: #2b2b2b;
    --nylas-base-600: #2b2b2b;
    --nylas-base-700: #2b2b2b;
  }
}
`;

export const localSchedulerPreviewRootStyle = `
::part(ic__label),
::part(ic__input),
::part(id_dropdown-input),
::part(sd_dropdown_label),
::part(sd_dropdown-button),
::part(msd_dropdown-label),
::part(msd_dropdown-button),
textarea-component::part(tc__label),
textarea-component::part(tc__textarea) {
  font-family: 'Montserrat' !important;
  outline-color: #bea06e !important;
}

.radio-group,
.checkbox-container {
  --nylas-font-family: 'Montserrat', sans-serif !important;
}

::part(ic__input)::placeholder,
::part(nbf__input-textfield)::placeholder {
  color: #bea06e !important;
}

.radio-group label .radio-option input[type=radio i],
.dropdown-content ul li label input {
  accent-color: #3d3d3d !important;
}

multi-select-dropdown::part(msd_dropdown-label) {
  font-size: 16px;
}
`;
